






























































































import { Component, Vue } from "vue-property-decorator";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";

import TheTemplateH from "@/general/components/templates/TheTemplateH.vue";
import TheHDetail from "@/general/components/pages/parts/PointHistoryList/layout/TheHDetail.vue";

import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";

import TextLabel from "@/common/components/atoms/TextLabel.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";

import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HSpecColumnList from "@/general/components/pages/parts/PointHistoryList/HSpecColumnList.vue";
import D03Details from "@/general/components/pages/parts/ApplyCartItems/D03Details.vue";
import HShippingDetails from "@/general/components/pages/parts/PointHistoryList/page-of-use-the-point/HShippingDetails.vue";
import HDeliveryDetails from "@/general/components/pages/parts/PointHistoryList/page-of-use-the-point/HDeliveryDetails.vue";
import HPaymentDetails from "@/general/components/pages/parts/PointHistoryList/page-of-use-the-point/HPaymentDetails.vue";
import HGiftCodeDetails from "@/general/components/pages/parts/PointHistoryList/page-of-use-the-point/HGiftCodeDetails.vue";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";

import { getTransactionExchange } from "@/general/store/api";

import {
  getQueryString,
  setQueryString
} from "@/common/assets/js/utils/queryParams";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    TheTemplateH,
    TheHDetail,
    TheBreadcrumb,
    TextLabel,
    PointNotation,
    SmallText,
    HContainer,
    HSpecColumnList,
    D03Details,
    HShippingDetails,
    HDeliveryDetails,
    HPaymentDetails,
    HGiftCodeDetails
  }
})
export default class PointHistoryUsageInfo extends Vue {
  usageData: any = {};
  headerHeightToStyle = 0;

  $refs!: {
    theHeader: TheHeader;
  };

  async setPageData() {
    const breadcrumb = [
      {
        text: "",
        url: CONST_DATA.SITE_MAP.TOP_PAGE,
        pageType: "home"
      },
      {
        text: "ポイント確認",
        url: `${CONST_DATA.SITE_MAP.POINT_CONFIRMATION}?${getQueryString({
          ...this.params,
          id: undefined
        })}`,

        pageType: "lower"
      },
      {
        text: "ポイント詳細",
        url: "",
        pageType: "lower"
      }
    ];

    await commons.getBreadcrumb(breadcrumb);
  }

  params = {
    id: "",
    redemption: 0,
    transaction_type: "",
    transaction_direction: "",
    filter_position: "",
    refine_position: "",
    ordering: "",
    page: "1",
    search: ""
  };

  viewProduct() {
    window.location.href =
      "/product-details/?id=" + this.usageData?.product_details?.product_id;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queries = [
      { k: "id" },
      { k: "redemption" },
      { k: "transaction_type" },
      { k: "transaction_direction" },
      { k: "filter_position" },
      { k: "refine_position" },
      { k: "ordering", v: "-created_at" },
      { k: "page", v: 1 },
      { k: "search" }
    ];
    this.params = setQueryString(this.params, queries);
    console.log(this.params);

    if (this.params.redemption) {
      this.params.redemption = parseInt(this.params.redemption + "", 10);
    }
    await this.setPageData();

    await this.retrieveGrantPointDetails(parseInt(this.params.id));
  }

  async retrieveGrantPointDetails(id: number) {
    const transaction_exchange = await getTransactionExchange(id);

    const delivery_address = [
      transaction_exchange?.zip_code +
        " " +
        transaction_exchange?.prefecture +
        " " +
        transaction_exchange?.address_line_1 +
        " " +
        transaction_exchange?.address_line_2
    ];

    this.usageData = {
      application_id: {
        label: "申込番号",
        id: transaction_exchange.apply_id
      },
      product_details: {
        image: transaction_exchange.image_url,
        product_name: transaction_exchange.name,
        product_id: transaction_exchange.menu_no,
        price: transaction_exchange.point_required,
        premium_id: 10,
        plan_id: transaction_exchange.plan_id,
        date: this.$dayjs
          .utc(transaction_exchange.register_datetime)
          .locale("ja")
          .format("YYYY/MM/DD"),
        delivery_address,
        redemption_type: transaction_exchange.redemption_type
      },
      point: {
        usage: transaction_exchange.points,
        sign: false
      },
      quantity: transaction_exchange.quantity,
      delivered:
        transaction_exchange.status === CONST_DATA.TRANSACTION_STATSUS.PENDING
          ? false
          : true,
      shipping_address: delivery_address
    };
  }

  get appId() {
    return this.usageData.application_id;
  }

  get productDetails() {
    return this.usageData.product_details;
  }

  get delivered() {
    return this.usageData.delivered;
  }

  get point() {
    return this.usageData.point;
  }

  get paymentDetails() {
    return this.usageData.payment_details;
  }

  get usagePoint() {
    return {
      point: this.usageData.point.usage,
      sign: this.usageData.point.sign
    };
  }

  get productDomain(){
    let product_domain
    if(this.usageData.product_details.redemption_type == 1){
      product_domain = process.env.VUE_APP_LIFE_DOMAIN
      + '/product/detail-life/catExl=null/catLrg=null/catMid=null/catSml=null/menuNo=' 
      + this.productDetails.product_id 
      + '/plans/planId=' 
      + this.productDetails.plan_id
    }else{
      product_domain = process.env.VUE_APP_SHOP_DOMAIN
      + '/product/detail-goods/menuNo='
      + this.productDetails.product_id
    }
    return product_domain
  }

  get productDetailsSpec() {
    const quantity = this.usageData.quantity;
    const spec = [
      {
        label: "個数",
        detail: [quantity + ""]
      }
    ];
    return spec;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }
}
